import React, { useState } from 'react';
import { API_URL } from '../reusable/url';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

const GenerateAdminToken = () => {
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const authToken = useSelector((state) => state.user.token);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(API_URL('generate-admin-token'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error('Failed to generate token');
      }
      const data = await response.json();
      setToken(data.token);
      toast.success('Token generated successfully!');
    } catch (err) {
      setError(err.message);
      toast.error('Failed to generate token');
    }
  };

  const handleEmailSend = () => {
    window.open(`mailto:${email}?subject=P-score App Admin Registration Token&body=Here is your registration token for P-score app: ${token}`);
  };

  return (
    <div className="user-registration-container">
      <h2>Generate Admin Registration Token</h2>
      <form onSubmit={handleSubmit}>
        <Box sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}>
          <TextField 
            required
            id="outlined-required-email"
            label="Admin Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            color="secondary"
            focused
            InputLabelProps={{ style: { color: 'darkviolet' } }}
            sx={{
              input: { color: 'navy' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'darkviolet' },
                '&:hover fieldset': { borderColor: 'darkviolet' },
                '&.Mui-focused fieldset': { borderColor: 'darkviolet' },
              },
            }}
          />
        </Box>
        <button className="btn-generate-user-token" type="submit">Generate Token</button>
      </form>
      {error && <p>{error}</p>}
      {token && (
        <Box sx={{ margin: 2, padding: 2, border: '1px solid navy', borderRadius: '5px', backgroundColor: 'whitesmoke' }}>
          <h3>Generated Token:</h3>
          <p style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>{token}</p>
          <button className="btn-send-token" onClick={handleEmailSend}>Send Token via Email</button>
        </Box>
      )}
    </div>
  );
};

export default GenerateAdminToken;
